/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:  Sep 18 2023 00:00:00 PM
 *
 *******************************************************/
//flow

import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { withI18n } from '@shopify/react-i18n';

import AddonSpecialDiscountExpiredBanner from './addon-discount-expired';
import PackageSpecialDiscountExpiredBanner from './package-discount-expired';

const SpecialDiscountExpiredNotification: React.FC<ComposedProps> = ({ subscription }) => {
  const { discountCode } = subscription;

  // ANALYTIC23 -> CODE_1 -> CODE_2 -> ANALYTIC23
  // recentCodeApplied will return ANALYTIC23
  // For case show expire discount code after 15 day from expire date,
  // For example, date 15 is expired, til date 16 it was re-subscribed
  // It turn to default full charge => field discountCode will be null

  const code: string =
    _.get(discountCode, 'code', null) || _.get(discountCode, 'recentCodeApplied', '');

  if (code?.includes('ANALYTIC23')) return <AddonSpecialDiscountExpiredBanner />;
  return <PackageSpecialDiscountExpiredBanner />;
};

const mapStateToProps = state => ({
  subscription: _.get(state.oauth, 'subscription', {})
});

export default connect(mapStateToProps)(withI18n()(SpecialDiscountExpiredNotification));
